import { AppConfig } from './AppConfig';

const baseUrl = 'https://pg-1278.pharmagarde.be';
const basePlannerUrl = 'http://ec2-63-33-193-111.eu-west-1.compute.amazonaws.com:8080';

const config: AppConfig = {
  configName: 'PG_1273',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
  dateTimeFormatWithDetails: 'DD/MM/YYYY HH:mm:ss.ss',
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc', // 'AIzaSyDmGkzn-SGGe3cnwIAopogWMYvT7_cJNV8'
};

export default config;
